(function () {
  'use strict';
  if (customElements.get('zt-instruction-video')) return;

  class InstructionVideo extends HTMLElement {
    connectedCallback() {
      if (!this.onClick) this.onClick = this.handleClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    reset() {
      const iframe = this.querySelector('iframe');
      if (iframe) iframe.remove();
      this.querySelector('[data-zt-video-play]').hidden = false;
      this.querySelector('[data-zt-video-close]').hidden = true;
    }

    handleClick(event) {
      const close = event.target.closest('[data-zt-video-close]');
      if (close && this.contains(close)) {
        this.reset();
        this.querySelector('[data-zt-video-play]').focus();
        return;
      }

      const play = event.target.closest('[data-zt-video-play]');
      if (!play || !this.contains(play) || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const id = this.dataset.videoId;
      if (!/^\d+$/.test(id)) return;
      event.preventDefault();
      if (this.querySelector('iframe')) return;

      document.querySelectorAll('zt-instruction-video').forEach((player) => {
        if (player !== this) player.reset();
      });
      const iframe = document.createElement('iframe');
      iframe.title = this.dataset.videoTitle;
      iframe.src = 'https://player.vimeo.com/video/' + id + '?autoplay=1&dnt=1';
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      this.querySelector('[data-zt-video-frame]').appendChild(iframe);
      play.hidden = true;
      this.querySelector('[data-zt-video-close]').hidden = false;
      iframe.focus();
    }
  }

  customElements.define('zt-instruction-video', InstructionVideo);
}());
